import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { ResetButton } from "../../../../helper/components/resetButton/ResetButton.js";
import styles from "./ItemButton.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ItemButton = /*#__PURE__*/forwardRef(({
  className,
  children,
  ...props
}, ref) => {
  return /*#__PURE__*/_jsx(ResetButton, {
    className: classnames(className, styles.button),
    ...props,
    ref: ref,
    children: children
  });
});
export const ItemDivButton = /*#__PURE__*/forwardRef(({
  className,
  children,
  ...props
}, ref) => {
  return /*#__PURE__*/_jsx("div", {
    className: classnames(className, styles.button),
    tabIndex: 0,
    ...props,
    ref: ref,
    children: children
  });
});